<header class="header-wrapper">
  <div>
    <div class="nav-part start">
      <div class="logo">
        <a><img [src]="logoImg" alt="siemens logo" /></a>
      </div>
      <div class="app-name">{{ 'header.toolTitle' | translate }}</div>
    </div>
  </div>
</header>
